import { useEffect } from 'react';

const useWindowFocus = (onFocusCallback) => {
    useEffect(() => {
        if (typeof onFocusCallback !== 'function') return;

        let focusTimeout = null;

        // Handler for visibility change (tab switching)
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                // Add a small delay to prevent rapid double-firing and give network time to wake up
                clearTimeout(focusTimeout);
                focusTimeout = setTimeout(() => {
                    onFocusCallback();
                }, 500);
            }
        };

        // Handler for window focus (switching back from another app)
        const handleFocus = () => {
            clearTimeout(focusTimeout);
            focusTimeout = setTimeout(() => {
                onFocusCallback();
            }, 500);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleFocus);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', handleFocus);
            if (focusTimeout) clearTimeout(focusTimeout);
        };
    }, [onFocusCallback]);
};

export default useWindowFocus;
